import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";

import {
  getRecharge,
  getCenterInfo,
  createQrPayment,
  createLinkPayment,
} from "../../actions/GenomicsAdminAction";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useRef } from "react";
import Loader from "../../Components/loader";
import moment from "moment";
import { useHistory } from "react-router-dom";
// import { getCentreCreationMasterForAdvanePayment } from '../actions/CollectionCentergnadmin';

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
      padding: "5px",
      textTransform: "capitalize",
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: "90%",
      flexGrow: 21,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    root: {
      flexGrow: 1,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentFilter: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentTable: {
      width: "100%",
      padding: "0px 0px 10px 0px",

      marginTop: "20px",
      minHeight: "300px",
    },
    centerIt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    startIt: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem",
      width: "100%",
    },
    table: {
      maxWidth: "100%",
      margin: "auto",
    },
    tableRow: {
      border: "none",
      padding: "5px",
      textTransform: "capitalize",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

interface Props {
  getRecharge: any;
  recharge: any;
  getCenterInfo: any;
  centerInfo: any;
  createQrPayment: any;
  createLinkPayment: any;
  createQrCode: any;
  loading: Boolean;
}
const Recharge: React.FC<Props> = ({
  getRecharge,
  recharge,
  getCenterInfo,
  centerInfo,
  createQrPayment,
  createLinkPayment,
  createQrCode,
  loading,
}) => {
  const classes = useStyles();
  const timer = useRef<any>(0);
  const history = useHistory();
  const [centreId, setCentreId] = useState<string>("");
  const [paymentDateTime, setPaymentDateTime] = useState<any>("");
  const [paymentMode, setPaymentMode] = useState<string>("");
  const [advanceAmount, setAdvanceAmount] = useState<any>("");
  const [billNumber, setBillNumber] = useState<string>("");
  const [cashRecieptNumber, setCashRecieptNumber] = useState<string>("");
  const [qrUrl, setQrUrl] = useState<string>("");
  const [open, setOpen] = useState<any>(false);
  const [page, setPage] = useState<number>(0);
  const [disabledButton, setDisabledButton] = useState<boolean>(true);
  const [openQr, setOpenQr] = useState<any>(false);
  useEffect(() => {
    getCenterInfo();
  }, []);
  useEffect(() => {
    if (centreId !== "") {
      getRecharge(centreId);
    }
  }, [centreId]);
  useEffect(() => {
    if (centreId && paymentMode && advanceAmount) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [centreId, paymentMode, paymentDateTime, advanceAmount]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = recharge.links && recharge.links.next.split("?")[1];
      getRecharge(url);
    } else if (newPage < page) {
      let url = recharge.links && recharge.links.previous.split("?")[1];
      getRecharge(url);
    }
    setPage(newPage as number);
  };

  const submitForm = async (e: any) => {
    e.preventDefault();
    setDisabledButton(true);
    const isActive = true;
    const formData = {
      center_id: centreId,
      amount: advanceAmount,
    };

    if (centreId && paymentMode === "qrcode" && advanceAmount) {
      await createQrPayment(formData);
      getRecharge(centreId);
      setOpenQr(true);
    } else if (centreId && paymentMode === "link" && advanceAmount) {
      await createLinkPayment(formData);
      getRecharge(centreId);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = (url: any) => {
    setQrUrl(url);
    setOpen(true);
  };
  useEffect(() => {
    if (createQrCode.url !== undefined && openQr === true) {
      setQrUrl(createQrCode.url);
    }
  }, [createQrCode, openQr]);
  useEffect(() => {
    if (qrUrl !== "") {
      setOpen(true);
    }
  }, [qrUrl]);
  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <div className={classes.contentHeader}>
        <h2>Recharge</h2>
      </div>
      <div className={classes.contentFilter}>
        <form onSubmit={submitForm} autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <Autocomplete
                id="center-name"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setCentreId(obj.id);
                  }
                }}
                options={centerInfo.results || []}
                freeSolo
                blurOnSelect
                aria-required
                getOptionLabel={(option: any) =>
                  (option?.display_name === null
                    ? option?.name
                    : option?.display_name) +
                  "(" +
                  option?.center_code +
                  ")"
                }
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getCenterInfo(`?name_or_code=${newInputValue}`);
                  }, 1000);
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="Select Center"
                    variant="outlined"
                    style={{ width: "100%", margin: "0", padding: "0" }}
                    required
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                id="outlined-select-currency"
                select
                fullWidth
                variant="outlined"
                label="Payment Mode"
                className={"input"}
                value={paymentMode}
                onChange={(e) => setPaymentMode(e.target.value)}
                required
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"qrcode"}>QR Code</MenuItem>
                <MenuItem value={"link"}>Link</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="Recharge Amount"
                variant="outlined"
                className={"input"}
                value={advanceAmount}
                onChange={(e) => setAdvanceAmount(Number(e.target.value))}
                required
              />
            </Grid>
            {/* 3 */}

            {/* 4 */}
            <Grid item xs={12} md={3}>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                style={{ height: 55 }}
                fullWidth
                color="primary"
                disabled={disabledButton}
              >
                Proceed
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
      <div className={classes.contentTable}>
        <div style={{ width: "100%" }}>
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "540px" }}
          >
            {loading ? (
              <Loader />
            ) : (
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center">S. No.</StyledTableCell>
                    <StyledTableCell align="center">Center</StyledTableCell>
                    <StyledTableCell align="center">Amount</StyledTableCell>
                    <StyledTableCell align="center">Payment Id</StyledTableCell>
                    <StyledTableCell align="center">Url.</StyledTableCell>
                    <StyledTableCell align="center">Created At</StyledTableCell>
                    <StyledTableCell align="center">Status</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {recharge.results &&
                    recharge.results.length > 0 &&
                    recharge.results.map((payment: any, index: number) => {
                      return (
                        <StyledTableRow
                          key={index}
                          className={classes.tableRow}
                        >
                          <StyledTableCell align="center">
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell>
                            {payment?.center?.display_name === null
                              ? payment?.center?.name
                              : payment?.center?.display_name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {payment?.amount}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {payment?.paymentid}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {payment?.link_type === "link" ? (
                              <a target="_blank" href={payment?.payment_url} rel="noreferrer">
                                {payment?.payment_url}
                              </a>
                            ) : (
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleOpen(payment?.payment_url)}
                              >
                                {payment?.payment_url}
                              </span>
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {moment(payment?.created_at).format(
                              "DD-MM-YYYY, hh:MM A"
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {payment?.payment_status}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
                {recharge.results && recharge.results.length === 0 && (
                  <h6 style={{ textAlign: "center" }}>No Data Found</h6>
                )}
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={recharge.count || 0}
                  rowsPerPage={recharge.page_size}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </Table>
            )}
          </TableContainer>
        </div>
      </div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <img src={qrUrl} style={{ width: 300, height: "auto" }} />
      </Dialog>
    </main>
  );
};

const mapStateToProps = (state: any) => ({
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  createQrCode: state.GenomicsAdminReducer.createQrCode,
  recharge: state.GenomicsAdminReducer.recharge,
  loading: state.GenomicsAdminReducer.loading,
});

export default connect(mapStateToProps, {
  getRecharge,
  getCenterInfo,
  createQrPayment,
  createLinkPayment,
})(Recharge);
